/**
 * Global Imports
*/

import React from 'react';

/**
 * Root Imports
*/

import * as PermissionServices from '~/services/Permission';
import { ResourcesProvider } from '~/components/Provider';

/**
 * Exports
*/

export const PermissionContext = React.createContext({});

/**
 * 
 */
export function PermissionProvider(props) {
  return (
    <ResourcesProvider name='Permission' context={ PermissionContext } services={ PermissionServices }>
      { props.children }
    </ResourcesProvider>
  );
}